import React, { Component } from 'react';
import moment from 'moment';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import ceil from 'lodash/ceil';
import get from 'lodash/get';
import ReactTooltip from 'react-tooltip';
import If from '../../../components/Shared/If';
import { deepClone } from '../../../utils/copyObject';
import {whiteLabelStyling} from '../../../utils/constants';
import { calculateIndexRange } from '../../../utils/dashboardUtils';
import Paginations from '../../../components/Pagination/Pagination';
import { sortArray, sortDatesArray, sortNumbersArray, sortActionArray } from '../../../components/Shared/ReusablesUtils';
import '../Analytics.css';

import NoDataFound from '../../../assets/no-kpidata-range.png';

class ActionsGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            adminSortOrder: 'asc',
            gridPagination: {
                currentPage: 1,
                recordCount: 10
            },
            actionsAnalytics: this.props.actionsAnalytics && size(this.props.actionsAnalytics.length) > 0 ? deepClone(this.props.actionsAnalytics) : [],
            searchKey: this.props.searchObject && !isEmpty(this.props.searchObject.actionTitle) ? get(this.props.searchObject, 'actionTitle', '') : ''
        }
    }

    componentWillReceiveProps(nextProps) {
        let { searchKey } = this.state;
        if (nextProps.searchObject.actionTitle !== searchKey) {
            this.setState({
                gridPagination: {
                    ...this.state.gridPagination,
                    currentPage: 1,
                    recordCount: 10
                }
            });
        }
        this.setState({
            actionsAnalytics: nextProps.actionsAnalytics.map((eachChart) => {
                return { ...eachChart, actionTitle: eachChart.title || 'NA', createdBy: this.getCreatedByName(eachChart.userId), linkedEO: this.getEOLinkedInfo(eachChart), actionStatus: this.getActionStatus(eachChart) }
            })
        });
    }

    getCreatedByName = (item) => {
        if (!isEmpty(item.firstName) && !isEmpty(item.lastName) && item["firstName"] !== undefined && item["lastName"] !== undefined) {
            return `${item.firstName} ${item.lastName}`
        }
        return 'NA';
    }

    getEOLinkedInfo = (object) => {
        if(object.parentTask && object.parentTask.item) {
            const parentTask = object.parentTask.item;
            return parentTask.isDeleted !== undefined ? `${ parentTask.title} ( Archived )` : parentTask.title;
        }
        return '';

    }

    getActionStatus = (item) => {
        return item.isDeleted ? `Archived ` : item.completedDate ? 'Completed' : 'Active';      
    }
    renderList = (list) => {
        if (list && list.length > 0) {
            return list.map((item, index) => (
                <tr key={index}>
                    <td>
                        <span className="tooltip-text" data-tip={item.title || 'NA'}>{item.title || 'NA'}</span>
                        <ReactTooltip />
                    </td>
                    <td>{moment(item.createdOn).format('MM/DD/YYYY')}</td>
                    <td>{this.getCreatedByName(item.userId)}</td>
                    <td>
                    
                        <span className="tooltip-text" data-tip={this.getEOLinkedInfo(item)}>{this.getEOLinkedInfo(item)}</span>
                        <ReactTooltip />
                    </td>
                    <td>{this.getActionStatus(item)}</td>
                </tr>
            ));
        }
        return <tr><td>No record found</td></tr>;
    };

    getUserName = (item) => {
        if (!isEmpty(item.firstName) || !isEmpty(item.lastName)) {
            return `${item.firstName} ${item.lastName}`
        }
        return 'NA';
    }

    getColumnName = (columnName) => {
        const { actionsMetrices } = this.props;
        const columnDetails = actionsMetrices.filter((e) => e.id === columnName);
        return !isEmpty(columnDetails) ? columnDetails[0].name : '';
    }

    sortActionName = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.actionsAnalytics.map((eachChart) => {
            return { ...eachChart, actionTitle: eachChart.title || 'NA', createdBy: this.getCreatedByName(eachChart.userId), linkedEO: this.getEOLinkedInfo(eachChart), actionStatus: this.getActionStatus(eachChart) }
        });
        this.setState({ adminSortOrder }, () => {
            let updatedList = sortArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                actionsAnalytics: updatedList
            });
        });
    }

    sortDates = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.actionsAnalytics.map((eachChart) => {
            return { ...eachChart, actionTitle: eachChart.title || 'NA', createdBy: this.getCreatedByName(eachChart.userId), linkedEO: this.getEOLinkedInfo(eachChart), actionStatus: this.getActionStatus(eachChart)}
        });


        this.setState({ adminSortOrder }, () => {
            let updatedList = sortDatesArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                actionsAnalytics: updatedList
            });
        });
    }

    handlePageNavigation = (nextOrPrevious) => {
        if (nextOrPrevious === 'previous' || nextOrPrevious === 'next') {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: nextOrPrevious === 'previous' ? parseInt(this.state.gridPagination.currentPage - 1) : parseInt(this.state.gridPagination.currentPage + 1)
                    }
                }
            );
        } else {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: parseInt(nextOrPrevious)
                    }
                }
            );
        }

    }


    handleRecordCountChange = (event) => {
        let { value } = event.target;
        let { gridPagination: { recordCount } } = this.state;
        this.setState({ gridPagination: { ...this.state.gridPagination, recordCount: parseInt(value), totalPage: ceil(size(this.state.userAnalytics) / recordCount) } });
    }

    generatePageNumbers = (actionsAnalytics) => {
        let { currentPage, recordCount } = this.state.gridPagination;
        let pageNumbers = [];

        if (recordCount > size(actionsAnalytics)) {
            pageNumbers = [];
        } else {
            for (let i = 1; i <= ceil(size(actionsAnalytics) / recordCount); i++) {
                pageNumbers.push(<li key={i} className="page-item"><span className={currentPage === i ? 'page-link currentpage-active' : 'page-link'} onClick={() => this.handlePageNavigation(i)}>{i}</span></li>)
            }
        }
        // Slice only 1 to 10 Page
        let pageNumbersInitial = pageNumbers.slice(0, 10);
        return pageNumbersInitial;
        
    }

    render() {

        let { actionsAnalytics } = this.state;
        let { gridPagination: { currentPage, recordCount } } = this.state;
        let test = calculateIndexRange(currentPage, recordCount);
        const slicedRecords = actionsAnalytics.slice(test.begin, test.end);
        let totalPageNumber = ceil(size(actionsAnalytics) / recordCount);
        let nodatafound = null;
        if(actionsAnalytics.length === 0){
            nodatafound = (
            <div className="text-center no-data-available-desc">
              <p style={{ marginBottom: '0px' }}>Looks like there's no data available for the parameters you selected.</p>
              <p> Try adjusting your filters, dates.</p>
              <img src={NoDataFound} className="no-kpi-date-range" />
            </div>
          )
        }
        console.log(this.props)
        return (
            <div>
                {actionsAnalytics.length > 0 && (
                <div>
                <div className="row p-0 m-0 mt-3 mb-2 table-responsive-sm table-ellipsis">
                    <table 
                    className="toolkit-list table text-primary-color tool-list-font" 
                   
                    >
                        <thead>
                            <tr className="col-sm-4 mb-3">
                                <th scope="col" className='bottom-border-color' 
                                style={{ borderTop: 'none', width: '400px' }}
                                // style={whiteLabelStyling(['color','borderBottomColor'], this.props.user.organizationId)}
                                >
                                    <span className="table-sort-title">Action Title</span>
                                    <span onClick={() => this.sortActionName('actionTitle')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Date Created</span><span onClick={() => this.sortDates('createdOn')} className="table-sort-icon fa fa-sort"></span></th>
                                
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Created By</span><span onClick={() => this.sortActionName('createdBy')} className="table-sort-icon fa fa-sort"></span></th>
                                
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Linked EO</span><span onClick={() => this.sortActionName('linkedEO')} className="table-sort-icon fa fa-sort"></span></th>
                              
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Action Status</span><span onClick={() => this.sortActionName('actionStatus')} className="table-sort-icon fa fa-sort"></span></th>
                               
                            </tr>
                        </thead>
                        <tbody>{this.renderList(slicedRecords)}</tbody>
                    </table>
                </div>
                <If condition={size(actionsAnalytics) > 0}>
                    <Paginations
                        currentPage={currentPage}
                        totalPageNumber={totalPageNumber}
                        handlePageNavigation={this.handlePageNavigation}
                        Analytics={actionsAnalytics}
                        generatePageNumbers={this.generatePageNumbers}
                        handleRecordCountChange={this.handleRecordCountChange}
                        recordCount={recordCount}
                        totalRecords={size(actionsAnalytics)}
                    />
                </If>
                </div>
                )}
                {nodatafound}
            </div>
        )
    }
}

export default ActionsGrid;